import React, { Component, ReactNode } from 'react';
import SideNav from '../../../container/organisms/SideNavContainer';
import HeaderNav from '@common/component/organisms/HeaderNav';
import classNames from 'classnames';

interface LayoutProps {
  children?: ReactNode;
  isLoggedIn: boolean;
}

export default class extends Component<LayoutProps, any> {
  constructor(props: LayoutProps) {
    super(props);
    this.state = {
      isSidebarOpen: true,
      isSidebarCollapse: true,
      isSp: false,
      isTablet: false,
    };

    this.handleSidebarOpen = this.handleSidebarOpen.bind(this);
    this.handleSidebarCollsapse = this.handleSidebarCollsapse.bind(this);
    this.onResizeWindow = this.onResizeWindow.bind(this);
  }

  componentWillMount() {
    this.setState({
      isSp: window.innerWidth < 600,
      isTablet: window.innerWidth >= 600 && window.innerWidth < 1025,
    });
    window.addEventListener('resize', this.onResizeWindow);
    this.setCustomCSS();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResizeWindow);
  }

  setCustomCSS() {
    // CSS変数 レイアウト用設定
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
  }

  onResizeWindow() {
    this.setCustomCSS();

    this.setState({
      isSp: window.innerWidth < 600,
      isTablet: window.innerWidth >= 600 && window.innerWidth < 1025,
      isSidebarOpen: true,
      isSidebarCollapse: true,
    });
  }

  handleSidebarOpen() {
    this.setState({ isSidebarOpen: !this.state.isSidebarOpen });
  }

  handleSidebarCollsapse() {
    this.setState({ isSidebarCollapse: !this.state.isSidebarCollapse });
  }

  render() {
    const { isSp, isTablet, isSidebarOpen, isSidebarCollapse } = this.state;
    const { isLoggedIn } = this.props;
    // サイドバー表示
    // 1. ログインしていない時は表示しない
    // 2. PC, Tabletは常に表示する
    // 3. SPのとき、ナビゲーションがONのとき表示する
    const _isSidebarOpen = isLoggedIn && (!isSp || isSidebarOpen);

    // サイドバー縮小
    // 1. SP, PCの時は常に縮小しない
    // 2. Tabletのとき、ナビゲーションがONのとき表示する
    const _isSidebarCollapsed = isTablet && isSidebarCollapse;

    return (
      <div>
        {isSp && (
          <div className='layout-header'>
            <HeaderNav onClickNav={this.handleSidebarOpen} />
          </div>
        )}
        <div className={classNames('layout-main', !_isSidebarOpen && 'layout-main--close-sidebar', _isSidebarCollapsed && "layout-main--collapse-sidebar")}>
          {isSp && <div className='layout-main__overlay' onClick={this.handleSidebarOpen} />}
          {isTablet && <div className="layout-main__overlay-pc" onClick={this.handleSidebarCollsapse} />}
          <div className='layout-main__left'>
          <SideNav isHiddenHead={isSp} isCollapsed={_isSidebarCollapsed} toggleCollapse={this.handleSidebarCollsapse} />
          </div>
          <div className='layout-main__right' data-testid='children'>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}
